import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCartIcon } from '@heroicons/react/24/outline';

const CartPage: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="text-center py-12">
        <ShoppingCartIcon className="h-16 w-16 text-gray-400 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2">장바구니가 비어있습니다</h2>
        <p className="text-gray-600 mb-6">상품을 추가하여 쇼핑을 시작해보세요!</p>
        <Link
          to="/products"
          className="bg-kahan-primary text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 inline-block"
        >
          상품 보러가기
        </Link>
      </div>
    </div>
  );
};

export default CartPage;